import { CheckboxStyleConfig } from '../types/checkbox-style-config';

export const styleConfig: CheckboxStyleConfig = {
  baseStyle: {
    label: {
      alignItems: 'baseline',
    },
    control: {
      boxSize: '2.5', //it needs to be updated
      padding: '2.5',
      border: '0.1', //it needs to be updated
      borderRadius: 'sm-md',
      boxShadow: 'none',
      _checked: {
        _focusVisible: {
          bg: 'blue.500',
          borderColor: 'blue.500', // while checked the icon color needs to be updated to white
        },
        _hover: {
          bg: 'blue.200',
          borderColor: 'blue.200',
        },
      },
      _disabled: {
        borderColor: 'grey.300',
        _checked: {
          bg: 'blue.200',
          color: 'blue.50',
        },
        _hover: {
          borderColor: 'grey.300',
        },
        _focusVisible: {
          borderColor: 'grey.300',
        },
      },
      _invalid: {
        borderColor: 'red.500',
      },
    },
  },
  variants: {
    default: {
      control: {
        borderColor: 'grey.400',
        _hover: {
          borderColor: 'blue.200',
        },
        _focusVisible: {
          borderColor: 'blue.500',
        },
      },
    },
    success: {
      control: {
        borderColor: 'green.500',
        _hover: {
          borderColor: 'green.500',
        },
        _focusVisible: {
          borderColor: 'green.500',
        },
        _checked: {
          borderColor: 'green.500',
        },
      },
    },
    alert: {
      control: {
        borderColor: 'orange.500',
        _hover: {
          borderColor: 'orange.500',
        },
        _focusVisible: {
          borderColor: 'orange.500',
        },
        _checked: {
          borderColor: 'orange.500',
        },
      },
    },
    error: {
      control: {
        borderColor: 'red.500',
        _hover: {
          borderColor: 'red.500',
        },
        _focusVisible: {
          borderColor: 'red.500',
        },
        _checked: {
          borderColor: 'red.500',
        },
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
};
